import React from 'react'
import TextField from '@material-ui/core/TextField'
import { AsYouType } from 'libphonenumber-js'

import { CreateContactInput } from 'src/graphql'

const formatPhoneNumber = (numbers: string) => {
  return new AsYouType('US').input(numbers)
}

const handlePhoneNumberChange = (
  mutableEvent: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  cb: (number: string) => void,
  previous: string | null | undefined,
) => {
  const { value } = mutableEvent.target
  cb(
    previous && value.length > previous.length
      ? formatPhoneNumber(value)
      : value,
  )
}

type Props<T extends CreateContactInput> = {
  contact: T
  onChange: (update: Partial<T>) => void
  fields: object
}

const ContactNumbersForm = <T extends CreateContactInput>(props: Props<T>) => {
  const {
    contact: {
      homePhone,
      workPhone,
      cellPhone,
      faxNumber,
      website,
      emailAddress,
    },
    fields,
    onChange,
  } = props

  const handleChange = <K extends keyof T>(key: K, value: T[K]) => {
    onChange(({ [key]: value } as unknown) as Partial<T>)
  }

  return (
    <div>
      <TextField
        value={homePhone}
        label={'Home Phone'}
        fullWidth={true}
        onChange={e =>
          handlePhoneNumberChange(
            e,
            number => handleChange('homePhone', number),
            homePhone,
          )
        }
        {...fields}
      />
      <TextField
        value={workPhone}
        label={'Work Phone'}
        fullWidth={true}
        onChange={e =>
          handlePhoneNumberChange(
            e,
            number => handleChange('workPhone', number),
            workPhone,
          )
        }
        {...fields}
      />
      <TextField
        value={cellPhone}
        label={'Cell Phone'}
        fullWidth={true}
        onChange={e =>
          handlePhoneNumberChange(
            e,
            number => handleChange('cellPhone', number),
            cellPhone,
          )
        }
        {...fields}
      />
      <TextField
        value={faxNumber}
        label={'Fax Number'}
        fullWidth={true}
        onChange={e =>
          handlePhoneNumberChange(
            e,
            number => handleChange('faxNumber', number),
            faxNumber,
          )
        }
        {...fields}
      />
      <TextField
        value={website}
        label={'Website'}
        fullWidth={true}
        onChange={e => handleChange('website', e.target.value)}
        {...fields}
      />
      <TextField
        value={emailAddress}
        label={'Email Address'}
        fullWidth={true}
        onChange={e => handleChange('emailAddress', e.target.value)}
        {...fields}
      />
    </div>
  )
}

export default ContactNumbersForm
